<app-header class="full-width"></app-header>
<main id="content" class="js-content" role="main">
    <div class="grid-row">
        <div class="column-two-thirds">
            <div class="back-link-wrapper">
                <a routerLink="/" class="back-link aa-link-size">Back</a>
            </div>
            <header class="page-header">
                <h1 class="aa-title-size" tabindex="0">Test error page</h1>
            </header>
        </div>
    </div>
</main>
